import React, { useState, useEffect }from "react";
import { useParams } from "react-router-dom";
import aktualnosciData from "./aktualnosciData";
import DescriptionWithImage from "./DescriptionWithImage";
import dofinasofanie from "./zdjecia/dofinasowanie/NCK.jpg"
import plakat from "./zdjecia/PlakatinformacyjnySEZON_finsowanie.png"
import stopka from "./zdjecia/dofinasowanie/Belkaloga.jpg"
import przed from "./zdjecia/dofinasowanie/flagaigodło.png"
import logo_MKiDN from "./zdjecia/logo_MKiDN(1).png"  
import belkasploty from "./zdjecia/belkaspoty.jpg"

import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";


const Rozszerzenie = () => {
  const { id } = useParams(); // Pobierz id z parametrów URL
  const selectedNews = aktualnosciData.find(news => news.id === parseInt(id)); // Znajdź news po id
  

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);
  
  if (!selectedNews) {
    return <div className="min-h-screen bg-[#0d0d0d] text-gray-400 flex items-center justify-center">Nie znaleziono takiej strony.</div>;
  }

  // Pobierz obrazy z selectedNews
  const carouselImages = selectedNews.carouselImages;

  return (
    <div className="bg-[#0d0d0d] min-h-screen p-6 mt-20">
      <div className="w-full md:w-3/5 lg:w-1/2 mx-auto mb-4 rounded-xl mt-8 md:mt-0">
  <div className="max-w-4xl mx-auto mb-10">
    <Carousel
      showThumbs={false}
      showStatus={false}
      infiniteLoop
      autoPlay
      interval={4000}
      swipeable
      emulateTouch
    >
      {selectedNews.carouselImages.map((img, index) => (
        <div key={index}>
          <img
            src={img.src}
            alt={img.alt}
            className="rounded-xl object-contain max-h-[500px]"
          />
        </div>
      ))}
    </Carousel>
  </div>
      </div>
      <h1 className="text-4xl font-semibold text-neutral-600 mb-2 text-white text-center">
        {selectedNews.title}
      </h1>
      <p
        className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"
        dangerouslySetInnerHTML={{ __html: selectedNews.content }}
      />

      {selectedNews.id === 1 && (
        
        <div className="text-center p-8">
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Pieśni Rzeki to działanie artystyczne skierowane do mieszkańców i gości miejscowości położonych
        wzdłuż podlaskiej rzeki Supraśl z Gmin: Michałowo, Supraśl, Gródek, Wasilków. Punktem wyjścia do
        działań jest spektakl Teatru Łątek Supraśl pn. „Pieśń rzeki". Powstał on na bazie zebranych polskich
        ballad ludowych, w których głównym wątkiem jest woda, ciecz, rzeka. W każdej z czterech miejscowości
        odbędą się warsztaty etnograficzne poświęcone tradycji, obrzędom i zwyczajom związanymi z wodą oraz
        warsztaty śpiewu tradycyjnego. Zwieńczeniem tych działań będzie plenerowy spektakl „Pieśni rzeki"
        wraz z muzyką na żywo, którą współtworzyć będą uczestnicy warsztatów śpiewaczych. Chcemy
        przypomnieć jak ważną rolę w lokalnej kulturze, tradycji i życiu małych społeczeństw pełniła niegdyś
        rzeka. Udział w każdym z wydarzeń jest bezpłatny.</p>
        <br></br>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>Warsztaty śpiewu tradycyjnego </strong>prowadzone przez Anię Brodę oraz Julitę Charytoniuk</p>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>Warsztaty wyplatania wianków połączone z gawędą etnograficzną</strong> prowadzone przez Emilię Szatyłowicz (Ruda na Podlasiu)</p>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>Pieśni Rzeki – spektakl plenerowy</strong> Teatru Łątek (Ewa i Krzysztof Zemło)</p>
        <br></br>
        <p className="text-2xl sm:text-3xl md:text-3xl lg:text-3xl text-gray-400"><strong>Warsztaty śpiewu tradycyjnego</strong></p>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>26 lipca 2024. godz. 16:00</strong> Supraśl, Centrum Kultury i Rekreacji w Supraślu, Cieliczańska 1 – prowadzenie Anna Broda</p>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>27 lipca 2024 godz. 16:00</strong> Wasilków – Miejski Ośrodek Animacji Kultury w Wasilkowie, Żurawia 13 – prowadzenie Anna Broda</p>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>16 sierpnia 2024, godz. 16:00</strong> Michałowo, Gminny Ośrodek Kultury w Michałowie, Białostocka 19 – prowadzenie Julita Charytoniuk</p>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>17 sierpnia 2024, godz. 16:00</strong> Gródek, Gminne Centrum Kultury w Gródku, Chodkiewiczów 4 - prowadzenie Julita Charytoniuk</p>
        <br></br>
        <p className="text-2xl sm:text-3xl md:text-3xl lg:text-3xl text-gray-400"><strong>Pieśni Rzeki – spektakl z muzyką na żywo i warsztaty etnograficzne</strong></p>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>27 lipca 2024, Supraśl</strong> (zakręt rzeki przy klasztorze)</p>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">18:30 Warsztaty wyplatania wianków - prowadzenie Emilia Szatyłowicz</p>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">21:00 Pieśni Rzeki - spektakl plenerowy (Krzysztof Zemło, Ewa Zemło)</p>
        <br></br>

        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>28 lipca 2024, Wasilków</strong> (Cypel nad rzeką Supraśl)</p>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">18:30 Warsztaty wyplatania wianków - prowadzenie Emilia Szatyłowicz</p>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">21:00 Pieśni Rzeki - spektakl plenerowy (Krzysztof Zemło, Ewa Zemło)</p>
        <br></br>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>17 sierpnia 2024, Michałowo</strong> (Zejście do rzeki przy amfiteatrze)</p>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">18:30 Warsztaty wyplatania wianków - prowadzenie Emilia Szatyłowicz</p>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">21:00 Pieśni Rzeki - spektakl plenerowy (Krzysztof Zemło, Ewa Zemło)</p>
        <br></br>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>18 sierpnia 2024, Gródek</strong> (nad Rzeką za Centrum Kultury)</p>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">18:30 Warsztaty wyplatania wianków - prowadzenie Emilia Szatyłowicz</p>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">21:00 Pieśni Rzeki - spektakl plenerowy (Krzysztof Zemło, Ewa Zemło)</p>
        <br></br>
        <h2 className="font-bold text-2xl sm:text-3xl md:text-3xl lg:text-3xl text-gray-400">Warsztaty śpiewu tradycyjnego  </h2>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Zapraszamy osoby śpiewające, ale też te które nie mają doświadczenia. Podczas zajęć uczestnicy poznają swój głos i jego możliwości. W trakcie warsztatów pojawią się ćwiczenia ruchowe,
oddechowe, rozluźniające struny głosowe, dykcyjne. Punktem wyjścia będą pieśni tradycyjne
wykorzystane sztuce „Pieśni rzeki”. Osoby chętne będą mogły wziąć udział jako wykonawcy partii
śpiewanych podczas spektaklu „Pieśni Rzeki”. Prowadzenie Ania Broda/Julita Charytoniuk</p>
<br></br>
        <h2 className="font-bold text-2xl sm:text-3xl md:text-3xl lg:text-3xl text-gray-400">Warsztaty wyplatania wianków i pogadanką etnograficzną.  </h2>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Zapraszamy wszystkich chętnych do udziału w warsztatach tworzenia wianków, które odbędą się przed wieczornym spektaklem. Podczas warsztatów poza wyplataniem wianków uczestnicy posłuchają opowieści o roli ziół i roślin w kulturze i tradycji, o zwyczajach związanych i tradycjach związanych z wodą. Prowadzenie Emilia Szatyłowicz</p>
        <br></br>
        <h2 className="font-bold text-2xl sm:text-3xl md:text-3xl lg:text-3xl text-gray-400">Pieśni Rzeki – spektakl plenerowy z muzyką na żywo Anny Brody</h2>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"> „Pieśni rzeki” to spektakl, do którego inspiracją były polskie ballady ludowe. Na ich bazie stworzono
teatrodyski - inscenizacje pieśni realizowane w różnych technikach teatru cieni i światła. Układają się one
w opowieść - teatralną balladę o miłości i śmierci . Ważnym był dobór utworów. Elementem wspólnym
dla wszystkich był motyw rzeki, wody, cieczy. Miłość jest bowiem nurtem, który nas porywa, czy tego
chcemy czy nie, i nie wiadomo gdzie nas zaniesie. Podczas spektaklu aktorzy-animatorzy nie
wypowiadają ani jednego słowa. Przemawiają obrazy, muzyka i śpiew, które stanowią warstwę
dźwiękową całego spektaklu. W trakcie spektaklu muzyka będzie grana na żywo (cymbały Anna Broda i
śpiew Anna Broda/Julita Charytoniuk i uczestnicy warsztatów śpiewu).</p>
<br></br>


          <h2 className="font-bold text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-white">
              Pieśni rzeki – rzeka tradycji (Zespół realizacyjny)
          </h2>
          <br></br>
          <p className=" text-white text-center text-2xl ">Krzysztof Zemło – reżyseria, aktor-animator</p>
          <p className=" text-white text-center text-2xl ">Ewa Zemło – scenografia, grafika, aktorka-animatorka</p>
          <p className=" text-white text-center text-2xl ">Ania Broda – muzyka, śpiew, warsztaty pieśni tradycyjnych</p>
          <p className=" text-white text-center text-2xl ">Julita Charytoniuk - śpiew, warsztaty pieśni tradycyjnych</p>
          <p className=" text-white text-center text-2xl ">Emilia Szatyłowicz – warsztaty wyplatania/etnograficzne</p>
          <p className=" text-white text-center text-2xl ">Przemysław Waczyński - koordynacja</p>


          <DescriptionWithImage
            imageSrc={carouselImages[4].src}
            altText={carouselImages[4].alt}
            title="Krzysztof Zemło"
            description="Aktor, animator, menadżer kultury, absolwent reżyserii na Akademii Teatralnej Wydziału Sztuki Lalkarskiej w Białymstoku, założyciel i prezes Stowarzyszenia Teatr Okno. Pracował jako aktor w Teatrze Lalki i Aktora w Łomży oraz współpracował z Teatrem Dramatycznym w Białymstoku. Obecnie kieruje Teatrem Łątek Supraśl oraz Miejskim Domem Kultury – Domem Środowisk Twórczych w Łomży. Reżyserował sztuki w teatrach instytucjonalnych i offowych. Organizował i prowadził liczne warsztaty teatralne adresowane do dzieci, młodzieży, dorosłych oraz osób ze środowisk zagrożonych wykluczeniem. Dwukrotny Stypendysta Marszałka Województwa Podlaskiego, Stypendysta Ministra Kultury odznaczony medalem Zasłużony Kulturze Polskiej. Założyciel i współwłaściciel Teatru Łątek Supraśl – najmniejszego teatru w Polsce."
          />

          <DescriptionWithImage
            imageSrc={carouselImages[7].src}
            altText={carouselImages[7].alt}
            title="Ewa Zemło"
            description="Absolwentka Liceum Plastycznego w Supraślu i Wydziału Architektury Politechniki Białostockiej. Autorka scenografii realizowanych w teatrach w Polsce i za granicą, m.in. Teatrze Dramatycznym w Białymstoku, Teatr Pleciuga w Szczecinie, Divadlo Loutek w Ostravie i Francji. Od lat współtworzy Teatr Łątek Supraśl oraz Teatr Okno kreując warstwę plastyczną spektakli i działań teatralnych. Realizator wielu warsztatów artystycznych i scenograficznych. Uprawia głównie olejne malarstwo sztalugowe. Swoje obrazy i instalacje prezentowała na wystawach zbiorowych i indywidualnych. Stypendystka Marszałka Województwa Podlaskiego. Założycielka i współwłaścicielka Teatru Łątek Supraśl – najmniejszego teatru w Polsce."
            reverse
          />

          <DescriptionWithImage
            imageSrc={carouselImages[5].src}
            altText={carouselImages[5].alt}
            title="Ania Broda"
            description="Anna Kowalska - pseudonim artystyczny Ania Broda to jeden z najoryginalniejszych głosów na polskiej scenie muzycznej. Piosenkarka, cymbalistka, kompozytorka, autorka tekstów, producentka. Posługuje się techniką śpiewu „białego”. Tworzy bardzo różnorodną w formie, nieprzewidywalną w stylu, absolutnie unikalną muzykę marzeń i wrażeń. Bardzo dobrze bawi się głębokim brzmieniem swojego głosu, siłą słowa, magią nieoczywistej melodii. Jest sama w sobie osobnym gatunkiem muzycznym. Przekracza granice wyznaczone przez kierunki w muzyce takie jak etno, jazz, folk, pop, muzyka dla dzieci. Łączy style poszukując własnego wyrazu w sztuce. Kształtuje duchową stronę tradycyjnej muzyki polskiej. Mistrzyni gry na cymbałach wileńskich, uderzanym instrumencie strunowym, który przywędrował do nas z Azji. Bierze udział w projektach związanych z muzyką, dawną, współczesną, eksperymentalną. Jako lokalna patriotka promuje tradycyjną muzykę z Warmii i Mazur."
          />

          <DescriptionWithImage
            imageSrc={carouselImages[3].src}
            altText={carouselImages[3].alt}
            title="Julita Charytoniuk"
            description="Animatorka kultury, śpiewaczka, rękodzielniczka. Uwielbia śpiewać, a jej ścieżki są ściśle związane są z muzyką tradycyjną Podlasia. Popularyzuje ją od niemal 20 lat – prowadzi badania terenowe, dokumentuje, uczy śpiewu, koncertuję oraz prowadzę działalność wydawniczą i animacyjną. Uczy się od wiejskich śpiewaczek i śpiewaków z Podlasia, Suwalszczyzny i Polesia Zachodniego (Ukraina, Białoruś). Łączy teorię z praktyką jako etnomuzykolożka i kulturoznawczyni. Swoją wiedzą i doświadczeniem dzielę się podczas warsztatów śpiewu tradycyjnego, na które często zaprasza do współpracy wiejskie mistrzynie. Śpiewa w zespołach Z Lasu, Południce, Pieśni Piękne, Biele, Polesie_PL. W białostockiej Kapeli Batareja odpowiadam za sekcję rytmiczną i śpiew. Koordynatorka wielu projektów kulturalnych związanych z muzyką, rękodziełem i językiem regionalnym. Realizuje swoje pomysły również w ramach stypendiów edukacyjnych i artystycznych. Jest również wiceprezeską Stowarzyszenia Dziedzictwo Podlasia oraz redaktorką portalu muzykatradycyjna.pl."
            reverse
          />
          <DescriptionWithImage
            imageSrc={carouselImages[6].src}
            altText={carouselImages[6].alt}
            title="Emilia Szatyłowicz"
            description=" Miłośniczka podlaskiego folkloru pochodząca z Czeremchy, przez niektórych kojarzona jako Ruda Na Podlasiu. Na swoim profilu pokazuje wielokulturowość regionu, podlaskie tradycje i zwyczaje, kuchnię, język, muzykę oraz ciekawe miejsca warte zobaczenia. Dużo miejsca w Jej działalności zajmuje różnego rodzaju rękodzieło, które sama tworzy jak i podziwia u innych lokalnych artystów. Inspiracje czerpie z rzeczy znalezionych w babcinych kufrach, wzorów zachowanych w podlaskich muzeach oraz naturalnego otoczenia."
            
          />
          <DescriptionWithImage
            imageSrc={carouselImages[8].src}
            altText={carouselImages[8].alt}
            title="Przemek Waczyński"
            description="Animator i menadżer kultury, bloger, trener. Już niemal 15 lat pracuje zawodowo w sektorze kultury. Swoją wiedzę i doświadczenie zdobywał uczestnicząc w dziesiątkach szkoleń, spotkań i wizyt studyjnych w najlepszych ośrodkach kultury w Polsce. Często się nią dzieli z innymi animatorami oraz menadżerami kultury. Stypendysta Ministra Kultury, w ramach którego realizował projekt „Podlaska Sieć Kultury”, trwający do dziś. Animator Programu Dom Kultury Plus Narodowego Centrum Kultury oraz propagator idei partycypacyjnego modelu instytucji kultury oraz sieciowania kadr kultury. Koordynator wielu projektów kulturalnych. Aktualnie pracuje w Miejskim Ośrodku Animacji Kultury w Wasilkowie, stale współpracuje z Teatrami Łątek Supraśl oraz Latarnia. Prowadzi blog pwkulturalnie.pl, na którym dzieli się swoimi refleksjami na temat kadr oraz instytucji kultury."
            reverse
          />
           <div className="flex justify-center mt-4">
            <img
              src={dofinasofanie}
              alt=" Narodowe Centrum Kultury"
              className="w-32 h-auto max-w-full object-contain sm:w-40 md:w-48 lg:w-60 xl:w-80"
              />
          </div>
        </div>
      )}
      {selectedNews.id === 3 && (
        <div className="text-center">
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Zapraszamy do wzięcia udziału w 4 edycji naszego kameralnego festiwalu. Teatr w Ogrodzie to multidyscyplinarny festiwal sztuk ze szczególnym naciskiem na działania teatralne.</p>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Cechą charakterystyczną wydarzenia, bardzo ważną dla jego unikalnego klimatu i charakteru, jest miejsce jego realizacji. Widzów gościmy u siebie - na jednym z podwórek należących do supraskich artystów. Tu rozstawiamy mobilną scenę teatralną, wiatę przerabiamy na galerię, taras na scenę muzyczną. Tak przygotowana przestrzeń pozwala uczestnikom spotkać się ze sztuką i ze sobą nawzajem. W tym roku, w kolejnych dwóch sierpniowych sobotach, widzowie będą mieli możliwość wzięcia udziału w wernisażu wystawy plastycznej, koncercie i dwóch spektaklach teatralnych.</p>
          <br></br>
          <h2 className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>PROGRAM</strong></h2>
          <br></br>
          <h3 className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>3 sierpnia</strong></h3>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">19.00 JAJO - wernisaż wystawy Ewy Zemło</p>
          <br></br>

          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">19.30 „Niebieskie wspomnienia” -koncert Julii Kuzyki</p>
          <br></br>
          <br></br>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">19.00 „Cudowni Mężczyźni z korbką” – spektakl Teatru A. Walnego</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">20.00 „Matecznik” – spektakl Teatru Łątek Supraśl</p>
          <br></br>
          <br></br>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Miejsce realizacji zadania Ogród przy ulicy Posterunkowej 1 A w Supraślu.</p>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Uczestnictwo we wszystkich działaniach jest bezpłatne.</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Organizator: Stowarzyszenie Teatr Okno</p>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Partner: Fundacja Teatr Łątek</p>
        </div>
      )}
      {selectedNews.id === 4 && (
        <div className="text-center">
          <div className="flex justify-center items-center my-6">
            <img src={przed} alt="Logo" className="w-auto max-w-[200px] h-auto" />
          </div>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">„Nosferatu – dziennik zarazy” to nowy spektakl wykonany w technice kina manualnego, który
przeznaczony jest do wystawiania w mobilnej scenie. Sztukę mogli zobaczyć widzowie w Supraślu,
Krypnie, Czeremsze, Goniądzu i Szudziałowie. Spektakl zrealizowano w ramach Programu OFF Polska. Premiera odbyła się 29 września 2024 roku w Supraślu. Dofinansowanie w kwocie 50 tysięcy złotych
pochodzi z programu OFF Polska 2024, którego cała wartość wynosi 1500 000.</p>
          <br></br>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Spektakl „Nosferatu – dziennik zarazy” jest inspirowany powieścią „Dracula” Brama Stokera oraz filmem „Nosferatu - symfonia grozy” w reżyserii Friedrich Wilhelm Murnau . Te zrealizowane już grubo ponad sto lat temu dzieła opowiadające historię wyprawy Jonathana Harkera do dalekiej Transylwanii i odwiedzin Hrabiego Drakuli w Londynie – stolicy ówczesnego świata, zrobiły wręcz zwrotną karierę, szczególnie w kulturze popularnej. Powodów takiego stanu rzeczy jest wiele, dominującym jednak jest podejmowanie w tych utworach archetypicznego tematu – walki życia ze śmiercią – rywalizacji Erosa i Tanathosa. W spektaklu za pomocą monochromatycznych form cieniowych, zaczerpniętych wprost z filmu Murnaua, w technice kina manualnego – przy pomocy recznie przesuwanej rolki folii -„taśmy filmowej”, spokojnie i z dystansem opowiadamy tę historie po swojemu. Ożywiamy postacie i fabułę , żeby zastanowić się, czy my, mieszkańcy współczesnego Wisborga jesteśmy żywi, czy po prostu jeszcze jesteśmy nieumarli…?</p>
          <br></br>
          <br></br>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Spektaklowi – kina manualnego towarzyszyć będzie wystawa, na której widzowie będą mogli
zobaczyć rożne wyobrażenia najbardziej znanego z wampirów – Draculi, które powstały podczas
ponad stuletniej historii kina.</p>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">20.00 „Matecznik” – spektakl Teatru Łątek Supraśl</p>
          <br></br>
          <br></br>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Miejsce realizacji zadania Ogród przy ulicy Posterunkowej 1 A w Supraślu.</p>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Uczestnictwo we wszystkich działaniach jest bezpłatne.</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Obsada – Ewa Agnieszka Zemłol, Krzysztof Zemło</p>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Reżyseria – Krzysztof Zemło</p>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Scenografia – Ewa Zemło</p>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Muzyka – Marcin Mickiewicz</p>

          <br></br>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">OFF Polska 2024 Instytutu Teatralnego im. Zbigniewa Raszewskiego. Spektakle będzie można
zobaczyć w 5 miejscowościach Województwa Podlaskiego.</p>
<br></br>
<br></br>

          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">29 września 2024 Supraśl (Posterunkowa 1) Premiera godz. 17:00, II granie godz. 19:00
Rezerwacja bezpłatnych wejściówek: godz. 17:00 rezerwacja , godz. 19:00 rezerwacja</p>
<br></br>
<br></br>

          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">5 października.2024 Czeremcha - plac przy Gminnym Ośrodku Kultury, ul. 1 Maja 77, godz. 18:00.
Rezerwacja bezpłatnych wejściówek: rezerwacja</p>
<br></br>
<br></br>

          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">11 października 2024 Krypno, plac przy Gminnym Ośrodku Kultury, Krypno Wielkie 9, godz.
18:00. Rezerwacja bezpłatnych wejściówek: rezerwacja</p>

<br></br>
<br></br>

          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">12 października 2024 Goniądz - plac przy Gminny Ośrodku Kultury w Goniądzu, ul. Stary Rynek
23, godz. 18:00. Rezerwacja bezpłatnych wejściówek: rezerwacja</p>
<br></br>
<br></br>

          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">13 października 2024 Szudziałowo - plac przy Gminnym Ośrodku Animacji Kultury i Rekreacji, ul.
Szkolna 2, godz. 18:00. Rezerwacja bezpłatnych wejściówek: rezerwacja</p>
<br></br>
<br></br>

          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Wydarzenie odbywa się dzięki wsparciu lukalnych ośrodków kultury: Gminnym Ośrodku Kultury
w Czeremsze, Gminnym Ośrodku Kultury w Krypnie, Gminnym Ośrodku Kultury w Goniądzu
oraz Gminnym Ośrodku Animacji Kultury i Rekreacji w Szudziałowie</p>
          <br></br>
          <br></br>
          <br></br>

          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Spektakl powstał w ramach programu OFF Polska organizowanego przez Instytut Teatralny im.Zbigniewa Raszewskiego . Dofinansowano ze środków Ministra Kultury i Dziedzictwa Narodowego.</p>
        <br></br>
        <br></br>
        <img src={stopka} alt="Logo" className="responsive-img" />
        <br></br>



      </div>
      )}
      {selectedNews.id === 5 && (
        <div className="text-center">
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Teatr Polska - 4 tysiące kilometrów teatralnej podróży</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Zakończyła się nasza niezwykła podróż ze spektaklem „Matecznik”, który przemierzył niemal 4000
kilometrów, odwiedzając 12 miejscowości w pięciu województwach. Od 18 października do 24 listopada
2024 roku spektakl został zaprezentowany w takich miejscach jak Myszków, Brzeszcze, Bystra, Drelów,
Piotrowice, Jaświły, Krzywe, Ełk, Chwałowice, Bieruń, Jastrzębie-Zdrój i Rydułtowy.</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">W każdym z tych miejsc „Matecznik” zgromadził publiczność, w sumie widowisko obejrzało ponad 600 widzów. Każdy z pokazów zwieńczony był rozmową, podczas której publiczność mogła podzielić się swoimi wrażeniami, zadawać pytania oraz dzielić się własnymi doświadczeniami. Te spotkania były dla nas niezwykle inspirujące, mamy nadzieję, że zarówno dla widzów.</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Matecznik swoisty hołd dla ludzi, miejsc i krajobrazów Podlasia, które stopniowo znikają z otoczenia. Sztuka powstała z inspiracji albumem fotograficznym „Wołkow” to widowisko pełne poezji wizualnej, w którym światło, cień i projekcje graficzne ożywiają wspomnienia dawnych krajobrazów.</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Widzowie mieli okazję przenieść się do świata przeszłości dzięki niezwykłej scenografii Ewy Zemło oraz animacjom autorstwa Agnieszki Waszczeniuk, stworzonym w technice animacji sypanej mieloną kawą. Muzykę do spektaklu skomponowała Ania Broda, nadając przedstawieniu niepowtarzalny klimat.</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Każda z miejscowości, które odwiedził „Matecznik”, była szczególnym przystankiem na tej naszej teatralnej trasie. Dzięki programowi Teatr Polska spektakl trafiliśmy do miejsc, gdzie być może nigdy byśmy nie mieli okazji dotrzeć.. Spotkania z publicznością – zarówno w małych ośrodkach kultury, jak i większych domach kultury – potwierdziły, jak wielka jest potrzeba obcowania ze sztuką na żywo, szczególnie w miejscach oddalonych od teatrów instytucjonalnych</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">„Matecznik” zakończył swoją trasę w Rydułtowach, zamykając jedną z najbardziej wyjątkowych podróży teatralnych w jaką mogliśmy wyruszyć. Przejechane kilometry, entuzjastyczne reakcje widzów i dyskusje pełne refleksji i pozytywnych emocji są najlepszym dowodem na to, że teatr tworzony po godzinach może być autentyczny i mieć moc poruszania serc i budzenia refleksji, niezależnie od miejsca, w którym się pojawił. Dziękujemy za możliwość wzięcia udziału w Programie Teatr Polska</p>
          <br></br>
          <br></br>
          <br></br>
          <h2 className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>MATECZNIK REALIZACJA OBJAZDU</strong></h2>
          <br></br>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Obsada - Krzysztof Zemło</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Reżyseria i opieka reżyserska – Krzysztof Zemło</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Scenografia i adaptacja scenograficzna – Ewa Zemło.</p>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Światło, dźwięk, multimedia – Ewa Zemło.</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Kierownik objazdu – Przemek Waczyński</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Technika – Piotr Sienkiewicz</p>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Partner: Fundacja Teatr Łątek</p>
          <br></br>
          <br></br>
          <br></br>
          <h2 className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>TRASA</strong></h2>
          <br></br>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Myszków, 18.10 Miejski Dom Kultury w Myszkowie godz. 18:00</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Bystra, 19.10 | Gminny Ośrodek Kultury "PROMYK" godz. 18:00</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Brzeszcze, 20.10 | Ośrodek Kultury w Brzeszczach godz. 18:00.</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Drelów, 26.10 | Gminne Centrum Kultury w Drelowie godz. 18:00</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Piotrowice, 27.10 | Centrum Kultury i Promocji Gminy Strzyżewice z siedzibą w Piotrowicach godz. 18:00</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Jaświły, 07.11 | Gminny Ośrodek Kultury w Jaświłach godz. 18:00</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Ełk, 08.11 | Ełckie Centrum Kultury godz. 18:00.</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Folwark Stary, 09.11 | Szkoła Podstawowa godz. 18:00.</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Rybnik, 21.11 | Dom Kultury w Rybniku-Chwałowicach godz. 18:00</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Bieruń, 22.11 | Bieruński Ośrodek Kultury godz. 18:00</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Jastrzębie-Zdrój, 23.11 | Miejski Ośrodek Kultury w Jastrzębiu-Zdroju godz. 18:00</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Rydułtowy, 24.11 | Rydułtowskie Centrum Kultury FENIKS godz. 18:00</p>
          <br/>
          <br/>
          <p class="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
              Program <strong>TEATR POLSKA</strong> organizowany jest od 2009 roku przez Instytut Teatralny im. Zbigniewa
              Raszewskiego ze środków Ministra Kultury, Dziedzictwa Narodowego. Więcej informacji na stronie:
              <a href="https://www.teatrpolska.pl" target="_blank" class="text-blue-500 hover:underline"> www.teatrpolska.pl</a> i
              <a href="https://www.facebook.com/TeatrPolska" target="_blank" class="text-blue-500 hover:underline"> www.facebook.com/TeatrPolska</a>.
          </p>
          </div>
        
      )}
      {selectedNews.id === 6 && (
        <div className="text-center">
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Nasz „Matecznik” został doceniony przez komisję programu Teatr Polska. Jako jeden z trzynastu spektakli w w październiku ruszy w trasę, by odwiedzić 12 miejscowości w 5 województwach. Od 18 października do 24 listopada 2024 „Matecznik” zostanie pokazany w Myszkowie, Brzeszczach, Bystrej, Drelowie, Piotrowicach, Jaświłach, Krzywem, Ełku, Chwałowicach, Bieruniu, Jastrzębiu-Zdroju i Rydułtowach. Zapraszamy do odwiedzania nas podczas trasy.</p>
          <br></br>
          <br></br>
          <h2 className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>W RAMCH PROJEKTU ODWIEDZILIŚMY</strong></h2>
          <br></br>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Myszków, 18.10 Miejski Dom Kultury w Myszkowie godz. 18:00</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Bystra, 19.10 | Gminny Ośrodek Kultury "PROMYK" godz. 18:00</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Brzeszcze, 20.10 | Ośrodek Kultury w Brzeszczach godz. 18:00.</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Drelów, 26.10 | Gminne Centrum Kultury w Drelowie godz. 18:00</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Piotrowice, 27.10 | Centrum Kultury i Promocji Gminy Strzyżewice z siedzibą w Piotrowicach godz. 18:00</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Jaświły, 07.11 | Gminny Ośrodek Kultury w Jaświłach godz. 18:00</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Ełk, 08.11 | Ełckie Centrum Kultury godz. 18:00.</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Folwark Stary, 09.11 | Szkoła Podstawowa godz. 18:00.</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Rybnik, 21.11 | Dom Kultury w Rybniku-Chwałowicach godz. 18:00</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Bieruń, 22.11 | Bieruński Ośrodek Kultury godz. 18:00</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Jastrzębie-Zdrój, 23.11 | Miejski Ośrodek Kultury w Jastrzębiu-Zdroju godz. 18:00</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Rydułtowy, 24.11 | Rydułtowskie Centrum Kultury FENIKS godz. 18:00</p>
          <br></br>
          <br></br>
          <br></br>
          <h2 className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>O SPETAKLU</strong></h2>

          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">"Patrzyliśmy na świat i rozmailiśmy. Ja przeważnie pytałem, a on odpowiadał... Taka rozmowa tutejszego z obcym...". Spektakl to podróż do miejsc, krajobrazów, okoliczności, historii z Podlasia których już w większości nie ma. Czas zawirował. Niepostrzeżenie z naszego krajobrazu znikły stogi siana, snopki zboża, płoty zrobione z drewnianych żerdzi, wozy z sianem. Ławki przed posesjami na których siadali miejscowi patrzyli na świat i starali się go zrozumieć są już w większości puste. „A może wszystko to jest ....tylko inaczej”. Dziś również, tak jak kiedyś wystarczy może się zatrzymać, usiąść. Rozejrzeć się wokół siebie, dostrzec otaczającą przestrzeń i piękno. Wejść w dialog z naturą i kulturą o tym, co nieprzemijalne.</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Spektakl jest inspirowany wydanym w 1984 albumie fotograficznym Wiktora Wołkowa pt. „Wołkow”. Pracowało nad nim trzech wybitnych podlaskich twórców: Wiktor Wołkow, Edward Redliński i Andrzej Strumiłło. Na bazie tej książki powstał autorski spektakl Krzysztofa Zemły pt. „Matecznik”. Czwarty twórca, tym razem teatralny, z wielkim uszanowaniem dla poprzednich trzech wielkich indywidualności, inspirując się książką przygotował widowisko sceniczne. Użył do tego eksplorowanych od lat w swojej twórczości technik związanych z teatrem cienia i światła. Spektakl podzielony jest na kilka opowieści, które ilustrowane są fotografiami. Widzowie mogą posłuchać historii o płotach, drzewach, wronach, drogach czy rzece. W specyficzny dla teatru Łątek sposób narracja uzupełniona jest fotografiami wyświetlanymi i animowanymi przy pomocy rzutników, grafoskopów na różnego rodzaju statycznych i ruchomych tłach. Dzięki użytym technikom i grze Zemły widz przenosi się do świata, którego już nie ma. W spektaklu padają pytania o los człowieka; o indywidualność; o przyjaźń; o istnienie smutku na świecie: o rzeczy proste, codzienne i ważne.</p>
          <br></br>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Spektakl „Matecznik” stanowi kontynuację artystycznych poszukiwań realizowanych w widowiskach „Pieśni Miłosne”(2019) oraz „Pieśń rzeki”(2020). Stosowane we wcześniejszych widowiskach (Romans Perlimplina i Belisy”, „Podróż”, „Dla mnie bomba!!!”, „Okienko”, „Pan Maluśkiewicz”) spektrum technik teatru cieni i światła wzbogacono w tych spektaklach o animację oraz przetworzenia gotowych zdjęć fotograficznych. Realizowano to głównie za pomocą różnego rodzaju starych technik projekcyjnych- rzutników slajdów oraz grafoskopów. Poza fotografiami Wiktora Wołkowa w spektaklu użyte zostały animacje, które specjalnie do tego spektaklu przygotowała supraska artystka Agnieszka Waszczeniuk - reżyserka filmów animowanych, autorka plastyki, scenarzystka i animatorka specjalizująca się w technice animacji sypanej mieloną kawą. Ta technika została użyta do stworzenia animacji nawiązujących do prac Andrzeje Strumiłły, który przygotował napisy do albumu. Scenografię do spektaklu przygotowała Ewa Zemło – artystka plastyk, aktorka i współzałożycielka Teatru Łątek w Supraślu. Za muzykę, która stanowiła klimatyczne tło dla przedstawionej historii oraz przenosiła widzów do świata zaklętego w fotografiach odpowiadała Ania Broda, która ją przygotowała specjalnie do tego spektaklu.</p>
          <br></br>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Reżyseria: Krzysztof Zemło</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Obsada - Krzysztof Zemło</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Muzyka: Ania Broda</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Scenografia: Ewa Agnieszka Zemło.</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Premiera: 18 września 2024, Supraśl. </p>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">czas trwania 55 minut + plus spotkanie z twórcami</p>
          <br></br>
          <br></br>
          <br></br>
          <h2 className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>TEATR POLSKA 2024</strong></h2>
          <br></br>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">TEATR POLSKA jest ogólnopolskim programem promocji teatru wśród mieszkańców miejscowości, mających ograniczony dostęp do oferty teatralnej. Powstał, by ułatwiać dostęp do oferty teatralnej przez wspieranie aktywności teatrów poza ich siedzibami i umożliwić prezentacje spektakli w miejscowościach mających utrudniony dostęp do kultury. Dzięki dofinansowaniu w ramach programu teatry instytucjonalne oraz organizacje pozarządowe mają możliwość zorganizowania pokazów spektakli w miastach, w których nie ma teatrów instytucjonalnych. Inspiracją dla powstania programu były objazdy teatralne organizowane w okresie międzywojennym przez Redutę Juliusza Osterwy i Mieczysława Limanowskiego, które przybliżały publiczności najważniejsze osiągnięcia polskiego teatru tamtego okresu. Program TEATR POLSKA organizowany jest w 2024 po raz szesnasty. Do tegorocznej edycji Zespół Sterujący ds. artystycznych zakwalifikował do drugiego etapu 13 przedstawień: Pokazy spektakli TEATR POLSKA trwają od 1 września do 30 listopada 2024 r.</p>
          <br></br>
          <br></br>
          <p class="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>Chłopaki płaczą</strong>, Teatr Dramatyczny im. Gustawa Holoubka, reż. Michał Buszewicz</p>
          <p class="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>Chopcy z Roosevelta</strong>, Teatr Nowy w Zabrzu, reż. Jacek Głomb</p>
          <p class="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>Hamlet-Komentarz</strong>, Fundacja Bral/Teatr Pieśń Kozła, reż. Grzegorz Bral</p>
          <p class="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>Historia Jakuba</strong>, Fundacja Zatrzymać Czas, reż. Aldona Figura</p>
          <p class="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>Ifigenia ze Splott</strong>, Teatr im. Stefana Jaracza w Łodzi, reż. Filip Gieldon</p>
          <p class="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>Kulka</strong>, Fundacja LALE.Teatr, reż. Tomasz Maśląkowski</p>
          <p class="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>Mała piętnastka – legendy pomorskie</strong>, Nowy Teatr im. Witkacego w Słupsku, reż. Tomasz Man</p>
          <p class="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>Matecznik</strong>, Fundacja Teatr Łątek, reż. Krzysztof Zemło</p>
          <p class="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>Morze ∞ możliwości</strong>, Fundacja Gra/nice, reż. Aga Błaszczak</p>
          <p class="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>Perfekty i Ambaras</strong>, Teatr Lalek „Pleciuga”, reż. Jakub Krofta</p>
          <p class="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>Pięć i pół człowieka</strong>, Olsztyński Teatr Lalek, reż. Andrzej Bartnikowski</p>
          <p class="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>Q&A</strong>, Stowarzyszenie Imagination Space Center, reż. Rachel Erdos</p>
          <p class="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>W maju się nie umiera. Historia Barbary Sadowskiej</strong>, Dom Spotkań z Historią, reż. Anna Gryszkówna</p>
          <br></br>
          <br></br>
          <p class="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
              Program <strong>TEATR POLSKA</strong> organizowany jest od 2009 roku przez Instytut Teatralny im. Zbigniewa
              Raszewskiego ze środków Ministra Kultury, Dziedzictwa Narodowego. Więcej informacji na stronie:
              <a href="https://www.teatrpolska.pl" target="_blank" class="text-blue-500 hover:underline"> www.teatrpolska.pl</a> i
              <a href="https://www.facebook.com/TeatrPolska" target="_blank" class="text-blue-500 hover:underline"> www.facebook.com/TeatrPolska</a>.
          </p>
          

          </div>
        
      )},
      {selectedNews.id === 8 && (
        <div className="text-center">
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Dotarły do nas dobre wieści z Warszawy! Fundacja Teatr Łątek otrzymała dotację z Ministerstwa Kultury i Dziedzictwa Narodowego w ramach programu TEATR 2025 na organizację Sezonu Teatralnego 2025. Bardzo się cieszymy i dziękujemy!</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Dzięki dotacji   na naszej scenie będziecie mogli zobaczyć spektakle Teatru Łątek oraz zaproszonych niezależnych teatrów lalek . Powstanie też wystawa dedykowana naszej najnowszej produkcji „Nosferatu - dziennik zarazy</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">To wszystko będzie bezpłatnie dla widzów. Zapraszamy do śledzenia naszych stron, szczegóły wkrótce.</p>
         

          </div>
        
      )},
      {selectedNews.id === 7 && (
        <div className="text-center">
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Fundacja Teatr Łątek oraz Gminne Centrum Kultury w Dobrzyniewie Dużym zapraszają młodzież w
wieku 10–16 lat na wakacyjną przygodę „Lato w teatrze”. Artystyczne półkolonie odbędą się w terminie
30 czerwca – 11 lipca 2025 r. (w godz. 9:00–15:00, z wyłączeniem sobót i niedziel; 10 lipca zajęcia w
godz. 14:00–20:00) w Wiejskim Domu Kultury w Pogorzałkach.</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Warsztaty są organizowane w ramach programu Lato w teatrze, którego operatorem jest Instytut Teatralny
im. Zbigniewa Raszewskiego. Program jest dofinansowany ze środków Ministerstwa Kultury i
Dziedzictwa Narodowego.</p>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Zajęcia poprowadzą aktorzy, tancerze oraz artyści plastycy. W półkoloniach weźmie udział 25
uczestników, którzy wspólnie z instruktorami przygotują spektakl podsumowujący dwa tygodnie twórczej
pracy.</p>
            <br></br>
            <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><span>„Czy ja też będę potworem?”</span> to projekt, w którym młodzież przyjrzy się światu dorosłych i zada sobie
ważne pytania: Jakimi dorosłymi chcemy być? Czy możemy uniknąć powielania błędów dorosłych? Czy
potrafimy zachować wrażliwość i autentyczność?</p>
            <br></br>
            <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Uczestnicy, inspirowani literaturą („Jaś i fasola”, „Hobbit”, „Opowieści z Narnii”), będą pracować
metodami teatru formy, tańca, animacji i działań plastycznych. Kluczową rolę odegrają improwizacja,
współpraca i eksperymentowanie z różnymi środkami wyrazu – od lalek po media społecznościowe.</p>
            <br></br>
            <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Najważniejsze będzie stworzenie przestrzeni, w której młodzież poczuje się bezpieczna, wysłuchana i
zaangażowana. Zwieńczeniem projektu będzie wspólny pokaz – efekt przemyśleń, emocji i pracy
zespołowej. Celem jest nie tylko artystyczny rezultat, ale również rozwój, integracja i wzmocnienie
młodych ludzi w ich drodze ku dorosłości.</p>
<br></br>
            <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Jeśli lubisz odkrywać, jesteś ciekawy/a świata, interesujesz się teatrem, muzyką, tańcem i literaturą – i
spędzasz wakacje na miejscu – zapraszamy do nas!</p>
         <br></br>
         <br></br>
         <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>Rekrutacja rusza 8 czerwca 2025 r. o godz. 17:00 na stronie: REKRUTACJA</strong></p>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">W formularzu online zapytamy Cię o:
            <ul>
              <li>imię i nazwisko dziecka</li>
              <li>wiek</li>
              <li>numer telefonu kontaktowego</li>
              <li>adres e-mail rodzica</li>
              <li>oraz poprosimy o krótką odpowiedź na pytanie: dlaczego dziecko chce wziąć udział w warsztatach?</li>
            </ul>
          </p>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Odpowiemy w ciągu 48 godzin od zgłoszenia. Decyduje kolejność zgłoszeń. <br></br> Koszt udziału: 200 zł brutto <br></br> Płatność wyłącznie przelewem. Szczegóły dotyczące płatności zostaną przesłane w e-mailu potwierdzającym udział.</p>
          <br></br>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400"><strong>Zespół realizujący:</strong></p>
          <br></br>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400 mb-2"><strong>Krzysztof Zemło</strong> warsztaty teatralne, koordynacja artystyczna</p>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Aktor, reżyser, animator i menadżer kultury. Absolwent reżyserii na Akademii Teatralnej w Białymstoku,
założyciel Teatru Okno i Teatru Łątek Supraśl – najmniejszego teatru w Polsce. Kieruje również Miejskim
Domem Kultury – DŚT w Łomży. Pracował jako aktor m.in. w Teatrze Lalki i Aktora w Łomży,
reżyserował w teatrach instytucjonalnych i offowych. Prowadzi liczne warsztaty teatralne, także dla osób
zagrożonych wykluczeniem. Stypendysta Ministra Kultury i Marszałka Woj. Podlaskiego, odznaczony
medalem „Zasłużony Kulturze Polskiej”.</p>
          <br></br>
          <br></br>
          <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400 mb-2"><strong>Ewa Zemło</strong> warsztaty scenograficzne</p>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Współtwórczyni i współwłaścicielka Teatru Łątek, odpowiedzialna za jego warstwę wizualną. Absolwentka Liceum Plastycznego w Supraślu i Wydziału Architektury PB. Tworzy scenografie w Polsce i za granicą, współpracując m.in. z Teatrem Dramatycznym w Białymstoku, Pleciugą w Szczecinie czy Divadlo Loutek w Ostravie. Malarka, scenografka, edukatorka. Stypendystka Marszałka Województwa Podlaskiego. Od 2024 roku prowadzi autorską galerię w Supraślu przy Teatrze Łątek. Realizatorka wielu warsztatów artystycznych i scenograficznych.</p>
        <br /><br />

        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400 mb-2"><strong>Dorota Baranowska</strong> warsztaty taneczne i choreograficzne</p>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Tancerka, choreografka, pedagożka tańca współczesnego i kontakt improwizacji. Twórczyni spektakli autorskich oraz współpracowniczka wielu grup artystycznych i instytucji, m.in. Teatru KoleGtyw, Grupy Przejściowej czy Towarzystwa Sztuki Surowej. Stypendystka Prezydenta Miasta Białegostoku i Marszałka Woj. Podlaskiego, nagrodzona m.in. tytułem „Idol Środowiska” i „Wolontariat Roku”. Prowadzi warsztaty artystyczne i taneczne, także z osobami z niepełnosprawnościami. Zafascynowana choreografią społeczną, tworzy spektakle inkluzywne i site-specific.</p>
        <br /><br />

        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400 mb-2"><strong>Urszula Chomik Kraszewska</strong> warsztaty medialne oraz językowe</p>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Aktorka, absolwentka Akademii Teatralnej Wydziału Sztuki Lalkarskiej w Białymstoku. Założycielka i reżyserka Teatru "Prestidigitator" przy XI LO, członkini Podlaskiego Oddziału Stowarzyszenia WSPÓLNOTA POLSKA. Reżyserka i instruktorka grup teatralnych w Pracowni Działań Kulturalnych Stowarzyszenia KLANZA. Realizatorka warsztatów teatralnych dla dzieci i młodzieży, jurorka konkursów recytatorskich i teatralnych w kraju i za granicą. Logopedka.</p>
        <br /><br />

        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400 mb-2"><strong>Sylwia Dec</strong> warsztaty medialne oraz opowiadania</p>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Pisarka, opowiadaczka. Pisze fantastykę, bo wierzy, że opowieści to lustra, które pokazują prawdy o nas i naszym świecie. Autorka terapeutycznych „Baśni o Przemianach” i serii „Za Siedmioma Światami” o kosmicznym weterynarzu. Pracuje też nad cyklem fantasy w autorskim uniwersum. Z wykształcenia socjolożka i arteterapeutka, od 15 lat związana z marketingiem internetowym. Prowadzi warsztaty pisarskie, arteterapeutyczne i zajęcia o historii miasta. Członkini Pisalni i Iskry. Zafascynowana sztuką opowiadania, rozwija się jako opowiadaczka. Kocha ludzi, dobre historie, koty i rośliny.</p>
        <br /><br />

        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400 mb-2"><strong>Izabela Zubrycka</strong> realizacja video</p>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Urodzona w 1998 roku. Absolwentka reżyserii filmowej i telewizyjnej w Państwowej Wyższej Szkole Filmowej, Telewizyjnej i Teatralnej w Łodzi, a także dziennikarstwa i fotografii na Uniwersytecie Warszawskim oraz Szkoły Wajdy. Realizatorka krótkometrażowych filmów fabularnych i dokumentalnych, nagradzanych na festiwalach.</p>
        <br /><br />

        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400 mb-2"><strong>Przemek Waczyński</strong> koordynator/kierownik wypoczynku</p>
        <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Animator, menadżer kultury, producent, trener i aktywista kulturalny. Stypendysta Ministra Kultury, w ramach którego zainicjował projekt „Podlaska Sieć Kultury” – działający do dziś. Animator Programu Dom Kultury+ Narodowego Centrum Kultury, promuje partycypacyjny model instytucji kultury oraz ideę współpracy i sieciowania kadr kultury. Koordynator licznych projektów kulturalnych i teatralnych. Stale współpracuje z Fundacją Teatr Latarnia oraz Teatrem Łątek Supraśl. Prowadzi blog „Przemek Waczyński – Kulturalnie”, gdzie dzieli się refleksjami o instytucjach kultury i ludziach je tworzących.</p>
        <br /><br />
        <section className="px-4 md:px-20 py-10 text-gray-400 text-2xl leading-relaxed">
  <h2 className="text-3xl font-bold text-white mb-6">Kontakt</h2>
  <p><strong>Koordynacja / Kierownik wypoczynku:</strong><br />
  Przemysław Waczyński<br />
  tel. <a href="tel:886536829" className="underline">886 536 829</a><br />
  e-mail: <a href="mailto:projekty@pwkulturalnie.pl" className="underline">projekty@pwkulturalnie.pl</a></p>

  <br />

  <h2 className="text-3xl font-bold text-white mb-6">Organizatorzy</h2>
  <p><strong>Organizator:</strong> Fundacja Teatr Łątek Supraśl<br />
  <strong>Partner:</strong> Gminne Centrum Kultury w Dobrzyniewie Dużym</p>

  <br />

  <h2 className="text-3xl font-bold text-white mb-6">Lato w Teatrze 2025</h2>
  <p>
    <strong>Lato w teatrze</strong> to ogólnopolski program wspierający samorządowe instytucje kultury i organizacje pozarządowe w tworzeniu młodym ludziom okazji do doświadczania teatru tam, gdzie mieszkają.
    Program bazuje na idei teatru jako formy spotkania oraz działa na rzecz rozwoju środowiska osób zajmujących się edukacją teatralną, animacją kulturalną i społeczną.
  </p>

  <p>
    Organizatorem programu jest <strong>Dział Pedagogiki Teatru Instytutu Teatralnego im. Zbigniewa Raszewskiego w Warszawie</strong>. Program składa się z konkursu grantowego na realizację dwutygodniowych warsztatów artystycznych dla dzieci i młodzieży, warsztatów z pedagogiki teatru oraz artystyczno-edukacyjnych projektów objazdowych w namiocie cyrkowym.
  </p>

  <p>
    Program <strong>Lato w teatrze</strong> jest finansowany ze środków <strong>Ministra Kultury i Dziedzictwa Narodowego</strong>.
  </p>

  <p>
    Konkurs grantowy pozwala wyłonić najbardziej wartościowe projekty, które poprzez działania teatralne rozwijają kompetencje społeczne dzieci i młodzieży, wspierają odkrywanie i wykorzystywanie ich potencjału oraz uczą dzielenia się z publicznością własnym przekazem. Teatralne działania mają także pokazać, że teatr jest miejscem otwartym dla każdego – miejscem spotkań, tworzenia i zabawy.
  </p>

  <p>
    W aktualnej, 18. edycji programu dofinansowanie otrzymało <strong>39 podmiotów</strong> z całej Polski – <strong>17 organizacji pozarządowych</strong> oraz <strong>22 samorządowe instytucje kultury</strong>. Aż <strong>29 projektów</strong> odbędzie się w miejscowościach do 20 tysięcy mieszkańców!
  </p>

  <p className="italic text-base mt-4">Lato w teatrze jest programem Instytutu Teatralnego im. Zbigniewa Raszewskiego finansowanym ze środków Ministra Kultury i Dziedzictwa Narodowego.</p>
</section>

</div>
        
)}
  {selectedNews.id === 12 && (
  <div className="text-center">
    <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
      „Teatralny Sezon Nieogórkowy w Teatrze Łątek Supraśl” to nasza odpowiedź na niedostateczną letnią ofertę teatralną.
      W najmniejszym teatrze w Polsce pokażemy spektakle z naszego repertuaru, a po każdym z nich zaprosimy widzów na spotkanie z twórcami.
    </p>
    <br />
    <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
      Chcemy w ten sposób utrzymać ciągłość repertuaru i dalej rozwijać unikalną scenę teatralną Podlasia.
      Dzięki współfinansowaniu ze środków Województwa Podlaskiego przygotowaliśmy cztery spektakle, w których publiczność będzie mogła uczestniczyć bezpłatnie.
    </p>
    <br />
    <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
      Zapraszamy w sierpniu i wrześniu do naszej siedziby w Supraślu.<br />
      Rezerwacja biletów wyłącznie online.
    </p>
    <br />

    <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
      „Matecznik” – 12 sierpnia 2025 godz. 19:00 <a href="https://app.evenea.pl/event/matecznik120825/" className="underline">Link do rezerwacji</a><br />
      „Matecznik” – 13 sierpnia 2025 godz. 19:00 <a href="https://app.evenea.pl/event/matecznik130825/" className="underline">Link do rezerwacji</a><br />
      „Dom Posterunkowa 1. Supraśl” – 20 września 2025 godz. 18:00 <a href="https://app.evenea.pl/event/posterunkowa200925/" className="underline">Link do rezerwacji</a> (bilety od 8 września, godz. 9:00)<br />
      „Nosferatu – dziennik zarazy” – 21 września 2025 godz. 19:00 <a href="https://app.evenea.pl/event/nosferatu210925/" className="underline">Link do rezerwacji</a> (bilety od 8 września, godz. 9:00)
    </p>

    <br /><br />
    <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
      <strong>MATECZNIK</strong><br />
      „Matecznik” to spektakl Teatru Łątek zrealizowany w 2022 roku w ramach Programu OFF Polska, inspirowany legendarnym albumem fotograficznym Wiktora Wołkowa „Rzeka, droga, płoty, krowy, konie, stogi, wrony, bociany, drzewa, krzyże” (1984), z opowieściami Edwarda Redlińskiego i koncepcją graficzną Andrzeja Strumiłły.
      Album stał się punktem wyjścia do refleksji o losie człowieka, indywidualności, przyjaźni i znaczeniu prostych rzeczy.
    </p>
    <br />
    <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
      Spektakl rozwija wcześniejsze projekty teatru, takie jak „Pieśni Miłosne” czy „Pieśń rzeki”, wzbogacając techniki teatru cieni i światła o projekcje, animacje oraz stare metody projekcyjne.
      Wykorzystano unikatową technikę „sypanej kawą” autorstwa Agnieszki Waszczeniuk. Scenografia: Ewa Zemło, muzyka: Ania Broda.
    </p>
    <br />
    <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
      <strong>Reżyseria i scenariusz:</strong> Krzysztof Zemło<br />
      <strong>Scenografia:</strong> Ewa Zemło<br />
      <strong>Muzyka:</strong> Ania Kowalska (Broda)<br />
      <strong>Animacje i video:</strong> Agnieszka Waszczeniuk
    </p>

    <br /><br />
    <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
      <strong>DOM POSTERUNKOWA 1. SUPRAŚL</strong><br />
      Opowieść o mieszkańcach i historii domu, w którym mieści się Teatr Łątek. Przez ponad 100 lat nazbierało się wiele historii.
      Reżyser Krzysztof Zemło podejmuje próbę opowiedzenia o świecie, którego już nie ma, w otoczeniu ścian i przedmiotów, które to wszystko pamiętają.
    </p>
    <br />
    <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
      <strong>Scenariusz i reżyseria:</strong> Krzysztof Zemło<br />
      <strong>Scenografia:</strong> Ewa Zemło<br />
      <strong>Muzyka:</strong> Marcin Mickiewicz
    </p>

    <br /><br />
    <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
      <strong>NOSFERATU – DZIENNIK ZARAZY</strong><br />
      Spektakl inspirowany „Draculą” Brama Stokera i filmem „Nosferatu – symfonia grozy” Murnaua. Opowiada historię w technice kina manualnego, wykorzystując monochromatyczne formy cieniowe.
    </p>
    <br />
    <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
      <strong>Obsada:</strong> Ewa Agnieszka Zemło, Krzysztof Zemło<br />
      <strong>Reżyseria:</strong> Krzysztof Zemło<br />
      <strong>Scenografia:</strong> Ewa Zemło<br />
      <strong>Muzyka:</strong> Marcin Mickiewicz
    </p>

    <br /><br />
    <section className="px-4 md:px-20 py-10 text-gray-400 text-2xl leading-relaxed">
      <h2 className="text-3xl font-bold text-white mb-6">Informacje organizacyjne</h2>
      <p>
        Zadanie „Teatralny Sezon Nieogórkowy w Teatrze Łątek Supraśl” jest współfinansowane ze środków Województwa Podlaskiego.
      </p>
    </section>
  </div>
  )},

  {selectedNews.id === 11 && (
  <div className="text-center">
    
    <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
      To był dla Teatru Łątek Supraśl dobry rok!    </p>
    <br />
    <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
Co najważniejsze, udało nam się w kolejnym sezonie cyklicznie grać na naszej scenie oraz w
teatralnym ogrodzie. Dzięki dofinansowaniu MKiDN mogliśmy również zaprosić zaprzyjaźnionych
twórców Anię Brodę, Walny – Teatr oraz Teatr Nemno. Podróżowaliśmy, graliśmy na festiwalach,
robiliśmy projekty i warsztaty, a tak rok 2025 wygląda w liczbach:    </p>
    <br />
    <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
- Zagraliśmy 61 spektakli. Przede wszystkim w Supraślu, ale również w całej Polsce: od Drawska i
Nowicy na zachodzie po Królowy Most i Bielawicze na wschodzie; Od Nowicy (Beskid Niski) i
Rzeszowa na południu po Kwidzyn i Dzięgiel na północy. Ruszyliśmy w trasę z naszą przyczepą -
teatrem na kółkach, który wraz z samochodem mają 14 metrów długości!    </p>
    <br />
    <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
- przeprowadziliśmy 10 warsztatów teatralnych    </p>
    <br />
    <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
- zrealizowaliśmy 3 projekty : „Lato w Teatrze 2025” - dofinansowany przez Instytut Teatralny im. Z.
Raszewskiego w Warszawie; „Teatrze Łątek Supraśl - Szósty sezon w najmniejszym Teatrze w Polsce”
– dofinansowany przez Ministerstwo Kultury i dziedzictwa Narodowego; „Teatralny sezon
nieogórkowy 2025” – dofinansowany przez Zarząd Województwa Podlaskiego    </p>
    <br />
    <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
- wystąpiliśmy na 11 festiwalach teatralnych    </p>
    <br />
    <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
- zdobyliśmy 2 nagrody :    </p>
    <br />
    <br />
    <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Nagrodę za „wyrażenie lalką teatru - przeniesienie starego kina do teatru za pomocą wyjątkowych
środków lalkarskich”. Na Międzynarodowym Festiwalu &quot;Lalka Też Człowiek” w Warszawie</p>
    <br />
    <br />
    <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">Nagrodę za reżyserię na 31. Międzynarodowym Festiwalu Teatrów Lalek i Formy „ Spotkania” w
Toruniu   </p>
    <br />



  </div>
  )},
  {selectedNews.id === 10 && (
  <div className="text-center">
    
    <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
      Jesień mięliśmy bardzo pracowitą. Kontynuowaliśmy granie w siedzibie teatru i nasze realizowane na miejscu projekty, prowadziliśmy cykliczne warsztaty dla głuchych w Stowarzyszeniu „Migiem” i… jeździliśmy po festiwalach teatralnych. Lubimy podróżować, spotykać nowych ludzi i to jedna z tych cudownych rzeczy, której dzięki teatrowi doświadczamy. Jesień obrodziła festiwalami. Wrzesień zaczęliśmy od Festiwalu INNOVICA w Nowicy, w Beskidzie Niskim. Następnie 20 i 21.09 pojechaliśmy z naszą scena na kółkach - przyczepą aż do Drawska na SZTUKATERIE. Od 7do10 października graliśmy na ANIMO w Kwidzynie – naszym ulubionym festiwalu, z którego prosto trafiliśmy do Warszawy na Festiwal LALKA TEŻ CZŁOWIEK. Festiwalowe tournée zakończyliśmy 19.10 w Toruniu na Festiwalu SPOTKANIA.
    </p>
    <br />
    <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
a… że niektóre z tych festiwali były konkursami :), zdobyliśmy:    </p>
    <br />
    <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
Nagrodę za „wyrażenie lalką teatru - przeniesienie starego kina do teatru za pomocą wyjątkowych
środków lalkarskich”. Na Międzynarodowym Festiwalu &quot;Lalka Też Człowiek” w Warszawie    </p>
    <br />

    <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
      Nagrodę za reżyserię na 31. Międzynarodowym Festiwalu Teatrów Lalek i Formy „ Spotkania” w
Toruniu 
</p>

  </div>
  )},
    {selectedNews.id === 13 && (
      <div className="text-center space-y-10">

    {/* Tytuł */}
    <h2 className="text-4xl md:text-5xl font-light tracking-widest text-gray-300">
      SPLOTY
    </h2>

    {/* Opis główny */}
    <div className="space-y-6">
      <p className="text-xl md:text-2xl px-6 md:px-32 leading-relaxed text-gray-400">
        „SPLOTY” to kameralny, autorski monodram Krzysztofa Zemły inspirowany fragmentami „Traktatu o łuskaniu fasoli” – poruszającej opowieści o pamięci, tożsamości i kruchości ludzkiego istnienia. W spektaklu będzie można zobaczyć scenografię przygotowaną przez Ewę Zemło oraz usłyszeć muzykę Ani Brody – cymbalistki, wokalistki i producentki.
      </p>

      <p className="text-xl md:text-2xl px-6 md:px-32 leading-relaxed text-gray-400">
        Realizacja przedstawienia jest możliwa dzięki wsparciu uzyskanemu z Krajowego Planu Odbudowy, co pozwala na pełne rozwinięcie artystycznej koncepcji projektu oraz jego szerokie udostępnienie publiczności – zarówno w przestrzeni teatralnej, jak i cyfrowej. Każdy z pięciu spektakli będzie transmitowany dla widzów spoza teatru. Ponadto powstanie rejestracja filmowa, którą udostępnimy w internecie. Po każdym ze spektakli odbędzie się rozmowa na temat sztuki z udziałem specjalisty od literatury oraz twórców spektaklu.
      </p>

      <p className="text-xl md:text-2xl px-6 md:px-32 leading-relaxed text-gray-400">
        Premiera oraz cztery kolejne pokazy spektaklu będą transmitowane na żywo w serwisie YouTube, a udział w wydarzeniach pozostaje bezpłatny, co dodatkowo wzmacnia ideę powszechnego dostępu do sztuki. Jeden ze spektakli przetłumaczony zostanie na Polski Język Migowy.
      </p>
    </div>

    {/* Terminy */}
    <div className="space-y-4">
      <h3 className="text-2xl tracking-wider text-gray-300">Terminy spektakli</h3>

      <div className="text-lg md:text-xl text-gray-400 space-y-2">
        <p>
          22.02 (niedziela), godz. 18:00 – premiera –{" "}
          <a 
            href="https://app.evenea.pl/event/sploty220225/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="underline text-gray-300 hover:text-white transition"
          >
            Link do wydarzenia
          </a>
        </p>

        <p>
          23.02 (poniedziałek), godz. 18:00 – pokaz z tłumaczeniem na PJM
        </p>

        <p>
          24.02 (wtorek), godz. 17:00 –{" "}
          <a 
            href="https://app.evenea.pl/event/sploty24022517/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="underline text-gray-300 hover:text-white transition"
          >
            Link do wydarzenia
          </a>
        </p>

        <p>
          24.02 (wtorek), godz. 19:00 –{" "}
          <a 
            href="https://app.evenea.pl/event/sploty24022519/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="underline text-gray-300 hover:text-white transition"
          >
            Link do wydarzenia
          </a>
        </p>

        <p>
          25.02 (środa), godz. 18:00 –{" "}
          <a 
            href="https://app.evenea.pl/event/sploty250225/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="underline text-gray-300 hover:text-white transition"
          >
            Link do wydarzenia
          </a>
        </p>
      </div>
    </div>

    {/* Opis spektaklu */}
    <div className="space-y-6">
      <p className="text-xl md:text-2xl px-6 md:px-32 leading-relaxed text-gray-400">
        Spektakl „Sploty” to autorski monodram Krzysztofa Zemły. W wielkiej, tętniącej życiem fabryce wydarzyła się kiedyś tragedia. Nie do końca poznajemy jej przyczyny. Wielkie emocje, nieszczęśliwa miłość… co dziś z tego zostało? W przepastnej przeszłości przepadli bohaterowie historii, co więcej – nie ma już samej fabryki. Pozostało po tym wszystkim zaledwie parę przedmiotów i opowieść. Wszystko lub niemal wszystko jest przeszłością.
      </p>

      <p className="text-xl md:text-2xl px-6 md:px-32 leading-relaxed text-gray-400">
        Główny bohater realizuje na scenie swoją opowieść o świecie, którego już nie ma, przy pomocy słów oraz przedmiotów – świadków tego, co minęło. Widowisko jest inspirowane prozą Wiesława Myśliwskiego.
      </p>

      <div className="text-lg md:text-xl text-gray-400 space-y-1">
        <p><span className="text-gray-300">Scenariusz i reżyseria</span> – Krzysztof Zemło</p>
        <p><span className="text-gray-300">Scenografia</span> – Ewa Zemło</p>
        <p><span className="text-gray-300">Muzyka</span> – Ania Broda</p>
        <p>
          Przedsięwzięcie objęte wsparciem z funduszy Unii Europejskiej w ramach Krajowego Planu Odbudowy i Zwiększenia Odporności.
        </p>
      </div>
    </div>

    {/* Biogramy */}
    <div className="space-y-10 text-left px-6 md:px-32">

      <div>
        <h3 className="text-2xl text-gray-300 mb-3">Krzysztof Zemło</h3>
        <p className="text-gray-400 leading-relaxed">
          Aktor, animator i menadżer kultury. Absolwent reżyserii na Wydziale Sztuki Lalkarskiej Akademii Teatralnej w Białymstoku, założyciel i prezes Stowarzyszenia Teatr Okno. Były aktor Teatru Lalki i Aktora w Łomży, współpracownik Teatru Dramatycznego w Białymstoku. Obecnie kieruje Teatrem Łątek Supraśl oraz Miejskim Domem Kultury – Domem Środowisk Twórczych w Łomży.
        </p>
        <p className="text-gray-400 leading-relaxed mt-3">
          Reżyserował spektakle w teatrach instytucjonalnych i offowych. Organizował i prowadził liczne warsztaty teatralne dla dzieci, młodzieży, dorosłych oraz osób z grup zagrożonych wykluczeniem. Dwukrotny stypendysta Marszałka Województwa Podlaskiego oraz stypendysta Ministra Kultury, odznaczony medalem „Zasłużony Kulturze – Gloria Artis”. Założyciel i współwłaściciel Teatru Łątek Supraśl – najmniejszego teatru w Polsce.
        </p>
      </div>

      <div>
        <h3 className="text-2xl text-gray-300 mb-3">Ewa Zemło</h3>
        <p className="text-gray-400 leading-relaxed">
          Absolwentka Liceum Plastycznego w Supraślu oraz Wydziału Architektury Politechniki Białostockiej. Autorka scenografii realizowanych w teatrach w Polsce i za granicą, m.in. w Teatrze Dramatycznym w Białymstoku, Teatrze Pleciuga w Szczecinie, Divadlo Loutek w Ostrawie oraz we Francji.
        </p>
        <p className="text-gray-400 leading-relaxed mt-3">
          Od lat współtworzy Teatr Łątek Supraśl i Teatr Okno, kreując warstwę plastyczną spektakli oraz projektów teatralnych. Prowadzi liczne warsztaty artystyczne i scenograficzne. Uprawia głównie olejne malarstwo sztalugowe. Swoje obrazy i instalacje prezentowała na wystawach zbiorowych i indywidualnych. Stypendystka Marszałka Województwa Podlaskiego. Założycielka i współwłaścicielka Teatru Łątek Supraśl – najmniejszego teatru w Polsce.
        </p>
      </div>

      <div>
        <h3 className="text-2xl text-gray-300 mb-3">Ania Broda</h3>
        <p className="text-gray-400 leading-relaxed">
          Anna Kowalska – pseudonim artystyczny Ania Broda to jeden z najoryginalniejszych głosów na polskiej scenie muzycznej. Piosenkarka, cymbalistka, kompozytorka, autorka tekstów, producentka. Posługuje się techniką śpiewu „białego”. Tworzy bardzo różnorodną w formie, nieprzewidywalną w stylu, absolutnie unikalną muzykę marzeń i wrażeń.
        </p>
      </div>

      <div>
        <h3 className="text-2xl text-gray-300 mb-3">O teatrze</h3>
        <p className="text-gray-400 leading-relaxed">
          Teatr Łątek Supraśl – najmniejszy teatr w Polsce – to niezwykłe miejsce stworzone przez Ewę i Krzysztofa Zemłów w ponad stuletnim domu przy ul. Posterunkowej 1 w Supraślu. Sala mieści zaledwie 10 widzów, a spektakle grane są w wyjątkowej, kameralnej atmosferze, często z wykorzystaniem technik teatru lalek, formy i cienia.
        </p>
        <p className="text-gray-400 leading-relaxed mt-3">
          Repertuar łączy autorskie przedstawienia gospodarzy z propozycjami zaproszonych artystów z Polski i zagranicy. Od 2019 roku teatr prowadzi regularne sezony artystyczne, organizuje warsztaty i plenerowe wydarzenia, przyciągając miłośników teatru z całego kraju. Teatr Łątek jest także zapraszany na liczne festiwale teatralne, gdzie prezentuje swoje kameralne, oryginalne spektakle.
        </p>
      </div>

    </div>
      <div className="flex justify-center items-center py-10">
        <div className="w-full max-w-3xl" style={{ aspectRatio: "16/9" }}>
          <iframe
            className="w-full h-full rounded-xl"
            src="https://www.youtube.com/embed/5nReLmZJZY0?start=19"
            title="Sploty – Teatr Łątek Supraśl"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>

      <div className="flex justify-center items-center py-10">
          <div className="text-center space-y-4">

            <img
              src= {belkasploty}
              className="mx-auto max-w-full h-auto opacity-90 hover:opacity-100 transition duration-300"
            />

          </div>
</div>
  </div>
  )},

    {selectedNews.id === 9 && (
  <div className="text-center">

  <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
    Dzięki dofinansowaniu ze środków Ministerstwa Kultury i Dziedzictwa Narodowego
    w okresie od czerwca do listopada 2025 roku zrealizujemy projekt szósty
    „Teatr Łątek Supraśl – szósty sezon teatralny w najmniejszym teatrze w Polsce”.
    W ramach projektu odbędzie się 12 spektakli teatralnych z naszego repertuaru
    oraz zaproszonych teatrów.
  </p>

  <br />

  <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
    Zadanie "Teatr Łątek Supraśl - szósty sezon teatralny w najmniejszym teatrze w
    Polsce" sfinansowano ze środków Ministerstwo Kultury i Dziedzictwa Narodowego.
    Program Teatr 2025.
  </p>

  <br />

  <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
    Podsumowanie
  </p>

  <br />

  <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
    W ramach projektu zaprezentowaliśmy 12 nieodpłatnych pokazów teatralnych.
    Spektakle odbywały się w teatrze oraz w sezonie letnim w przestrzeni plenerowej,
    w ogrodzie teatralnym i przyczepie teatralnej. W repertuarze znalazły się
    autorskie przedstawienia Teatru Łątek Supraśl oraz spektakle zaproszonych
    zespołów: Teatru Nemno i Walnego Teatru.
  </p>

  <br />

  <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
    Projekt obejmował prezentacje spektakli współczesnego teatru formy, teatru
    łątek, przedmiotu, cienia i światła, skierowane do widza dorosłego i
    senioralnego. Ważnym elementem była dostępność – dwa spektakle udostępniliśmy
    widzom głuchym poprzez tłumaczenie na Polski Język Migowy (PJM).
  </p>

  <br />

  <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
    Integralną częścią projektu były spotkania z artystami, organizowane po każdym
    pokazie. Twórcy dzielili się z publicznością wiedzą o technikach teatru formy,
    procesie twórczym oraz swojej drodze artystycznej. Spotkania miały charakter
    edukacyjny i sprzyjały budowaniu bezpośredniej relacji pomiędzy teatrem a
    widzami.
  </p>

  <br />

  <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
    Dodatkowym wydarzeniem towarzyszącym spektaklom „Nosferatu – dziennik zarazy”
    była wystawa „JA – DRAKULA”, prezentująca aktorów wcielających się w postać
    hrabiego Drakuli w historii światowego kina.
  </p>

  <br />

  <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
    Realizacja projektu wzmocniła pozycję Teatru Łątek Supraśl jako unikalnego
    miejsca prezentacji współczesnego teatru formy oraz stałej przestrzeni
    spotkania artystów i publiczności.
  </p>

  <br />

  <ul className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400 list-disc list-inside text-left">
    <li>10 czerwca 2025 – Nosferatu – dziennik zarazy – Teatr Łątek, godz. 18:00</li>
    <li>21 czerwca 2025 – Dom. Posterunkowa 1. Supraśl – Teatr Łątek, godz. 19:00</li>
    <li>29 czerwca 2025 – Dom. Posterunkowa 1. Supraśl – Teatr Łątek</li>
    <li>6 lipca 2025 – Nosferatu – dziennik zarazy – Teatr Łątek, godz. 18:00</li>
    <li>20 lipca 2025 – Matecznik – Teatr Łątek, godz. 19:00</li>
    <li>16 sierpnia 2025 – Pieśń Rzeki – Teatr Łątek, muzyka na żywo: Ania Broda (plener), godz. 20:30</li>
    <li>31 sierpnia 2025 – Giaur – Teatr Nemno, godz. 19:30</li>
    <li>6 września 2025 – Rozmowy Mistrza Polikarpa ze śmiercią – Walny Teatr, godz. 19:00</li>
    <li>5 października 2025 – Nosferatu – dziennik zarazy – Teatr Łątek, Supraśl, godz. 18:00</li>
    <li>8 listopada 2025 – Matecznik – Teatr Łątek (z tłumaczeniem na PJM), godz. 18:00</li>
    <li>23 listopada 2025 – Dom. Posterunkowa 1. Supraśl – Teatr Łątek (z tłumaczeniem na PJM), godz. 18:00</li>
  </ul>

  <br />

  <p className="text-2xl px-4 md:px-20 leading-relaxed text-gray-400">
    Zadanie "Teatr Łątek Supraśl - szósty sezon teatralny w najmniejszym teatrze w
    Polsce" sfinansowano ze środków Ministerstwo Kultury i Dziedzictwa Narodowego.
    Program Teatr 2025.
  </p>

<div className="mt-12 px-4">

  {/* LOGOTYPY */}
  <div className="flex flex-wrap items-center justify-center gap-8 mb-10">
    

    <img
      src={logo_MKiDN}
      alt="Belka logotypów"
      className="max-h-24 w-auto object-contain"
    />
  </div>

  {/* PLAKAT */}
  <div className="flex justify-center">
    <img
      src={plakat}
      alt="Plakat informacyjny – Program Teatr 2025"
      className="h-[600px] md:h-[850px] w-auto object-contain shadow-xl"
    />
  </div>

</div>


</div>

  )}


)

      

    </div>
  );
  
};


export default Rozszerzenie;
